import { HiOutlineChartBar } from "react-icons/hi2";
import { filterNavItems } from "./navAccess";
import {
  MAIN_MENU_ITEMS_RAW,
  SETTINGS_MENU_ITEMS_RAW,
  OEE_MENU_ITEMS_RAW,
  SPARE_PARTS_INVENTORY_MENU_ITEMS_RAW,
  RCA_MENU_ITEMS_RAW,
  CAPA_MENU_ITEMS_RAW,
  SAFETY_OBSERVATION_MENU_ITEMS_RAW,
  INCIDENT_MENU_ITEMS_RAW,
  HAZARD_MENU_ITEMS_RAW,
  PM_MENU_ITEMS_RAW,
  WORK_PERMIT_MENU_ITEMS_RAW,
  REPORTS_DETAIL_ITEMS_RAW,
} from "./navConfig";

/**
 * Flat list for cmdk: only routes the user may open (same gates as navConfig).
 * @returns {Array<{ id: string, path: string, label: string, group: string, keywords?: string[] }>}
 */
export function flattenNavForPalette(ctx) {
  const { hasPermission } = ctx;
  const out = [];

  out.push({
    id: "apps-hub",
    path: "/home/apps",
    label: "All modules",
    group: "Navigation",
    keywords: ["apps", "modules", "directory", "hub", "catalog", "launcher"],
  });

  const pushGroup = (groupLabel, items) => {
    const filtered = filterNavItems(items, ctx);
    filtered.forEach((item) => {
      out.push({
        id: item.key,
        path: item.path,
        label: item.label,
        group: groupLabel,
        keywords: item.keywords,
        icon: item.icon,
      });
    });
  };

  // Operations & Maintenance
  pushGroup("Operations", [
    ...PM_MENU_ITEMS_RAW.map(i => i.key === 'pm-hub' ? { ...i, key: 'MACHINE_HEALTH', label: 'Machine Health' } : i),
    ...MAIN_MENU_ITEMS_RAW.filter(i => ['work-order'].includes(i.key)),
    ...WORK_PERMIT_MENU_ITEMS_RAW,
    ...SPARE_PARTS_INVENTORY_MENU_ITEMS_RAW,
  ]);

  // Safety & Quality
  pushGroup("Health, Safety & Quality", [
    ...SAFETY_OBSERVATION_MENU_ITEMS_RAW,
    ...HAZARD_MENU_ITEMS_RAW,
    ...INCIDENT_MENU_ITEMS_RAW,
    ...MAIN_MENU_ITEMS_RAW.filter(i => ['kaizen', 'fives'].includes(i.key)),
  ]);

  // Intelligence & Continuous Improvement
  pushGroup("Intelligence & Continuous Improvement", [
    ...OEE_MENU_ITEMS_RAW,
    ...RCA_MENU_ITEMS_RAW,
    ...CAPA_MENU_ITEMS_RAW,
    ...MAIN_MENU_ITEMS_RAW.filter(i => ['opl', 'flowchart', 'bi-dashboard'].includes(i.key)),
    {
      key: "REPORTS_HUB",
      path: "/home/reports",
      label: "Reports Hub",
      icon: HiOutlineChartBar,
      permissionCode: "Reports.View",
      group: "Intelligence & Continuous Improvement",
      keywords: ["analytics", "reports dashboard", "bi"],
    }
  ]);

  // Detailed Reports
  pushGroup("Analytics Reports", REPORTS_DETAIL_ITEMS_RAW);

  // Admin & Settings
  pushGroup("Admin & Settings", SETTINGS_MENU_ITEMS_RAW);

  return out;
}

/**
 * Resolve a human title from pathname using palette paths (longest prefix wins).
 */
export function resolvePageTitle(pathname, paletteEntries) {
  if (pathname === "/home/apps") return "All modules";
  if (!pathname || !paletteEntries?.length) return "Dashboard";
  const sorted = [...paletteEntries].sort(
    (a, b) => (b.path?.length || 0) - (a.path?.length || 0),
  );
  for (const e of sorted) {
    if (!e.path) continue;
    if (e.path === "/home" && pathname === "/home") return e.label;
    if (e.path !== "/home" && pathname.startsWith(e.path)) {
      return e.label;
    }
  }
  const last = pathname.split("/").filter(Boolean).pop();
  if (!last) return "Dashboard";
  return last
    .replace(/-/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
